import React from 'react';

import { InputWithButton } from 'components/input-with-button';
import { routes } from 'utils/routing';
import { getFirstStringInLocaleBlockContent } from 'utils/sanity';

import {
  Container,
  Description,
  ErrorMessage,
  Icon,
  IconDescription,
  Label,
  PromoLink,
} from './promo-code-offer.styled';
import { IPromoCodeOfferViewProps } from './types';

const PromoCodeOfferView: React.FC<IPromoCodeOfferViewProps> = ({
  errorMessageId,
  isLoading,
  messages,
  offer,
  code,
  onSubmit,
  onChangeInput,
}) => {
  const description = getFirstStringInLocaleBlockContent(
    offer?.promoCodePanel?.promoCodeDescription
  );
  const label = getFirstStringInLocaleBlockContent(offer?.promoCodePanel?.promoCodeLabel);
  const link = offer?.promoCodePanel?.promoCodeLink || routes.base;

  return (
    <Container data-testid="promo-code-offer-container">
      {description && (
        <IconDescription>
          <Icon fill={Styles.color.black} width="9" height="11" />
          <Description>{description}</Description>
        </IconDescription>
      )}
      <InputWithButton
        buttonLabel={messages.buttonText}
        label={messages.inputLabel}
        name="promoCodeOffer"
        value={code}
        onChange={onChangeInput}
        isLoading={isLoading}
        onSubmit={onSubmit}
      />
      {errorMessageId && (
        <ErrorMessage data-testid="promo-code-offer-error-message">
          {messages.errorMessage}
        </ErrorMessage>
      )}
      {link && label && (
        <>
          <Label>{messages.noPromoCodeText}</Label>
          <PromoLink href={link}>{label}</PromoLink>
        </>
      )}
    </Container>
  );
};

export default PromoCodeOfferView;
